import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { kebabCase } from 'lodash';
import './styles.styl';
import icons from '../../assets/comet/comet.svg';

const Option = ({
  checked,
  data,
  isFinalAttempt,
  feedback,
  onClick,
  question,
  readOnly,
  type
}) => {
  const typeClassNames = {
    radio: 'radio-button',
    checkbox: 'checkbox'
  };

  const labelClasses = classNames(
    `comet-form__${typeClassNames[type]}`,
    'multiple-choice__question__option',
    checked &&
      feedback &&
      isFinalAttempt &&
      `multiple-choice__question__option--${feedback}`,
    {
      'multiple-choice__question__option--checked': checked
    }
  );

  const name = kebabCase(question);
  const id = `${name}-${kebabCase(data.label)}`;

  const handleClick = () => {
    !readOnly && onClick(data.label);
  };

  return (
    <label className={labelClasses} htmlFor={id}>
      <input
        id={id}
        type={type}
        className={`comet-form__${typeClassNames[type]}-input`}
        name={name}
        value={data.label}
        checked={!!checked}
        readOnly={!!readOnly}
        onClick={handleClick}
        onChange={handleClick}
      />
      <span
        className={`comet-form__${typeClassNames[type]}-visual`}
        focusable="false"
      >
        {type === 'checkbox' && (
          <svg
            className="comet-form__checkbox-checked-icon"
            aria-hidden="true"
            focusable="false"
          >
            <use xlinkHref={`${icons}#check`} />
          </svg>
        )}
      </span>
      <p className={`comet-form__${typeClassNames[type]}-text`}>{data.label}</p>
      {data.image && (
        <img
          className="multiple-choice__question__option__right-icon"
          src={data.image}
          alt={data.label}
        />
      )}
    </label>
  );
};

Option.defaultProps = {
  checked: false,
  feedback: null,
  readOnly: false
};

Option.propTypes = {
  checked: PropTypes.bool,
  data: PropTypes.object.isRequired,
  question: PropTypes.string.isRequired,
  feedback: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  type: PropTypes.string.isRequired
};

export default Option;



// WEBPACK FOOTER //
// ../core/src/components/MultipleChoice/Option.js